import { useEffect, useRef } from "react";
import { Reveal } from "./Reveal";
import { SERVICE_ICONS, ServiceIcon } from "../serviceIcons/icons";
import { usePlayer } from "../serviceIcons/motion";

const SERVICES = [
  { icon: "frontend", text: "Frontend development with React, Next.js and TypeScript." },
  { icon: "ml", text: "Machine learning, from training models to RAG search and LLM apps." },
  { icon: "fullstack", text: "Real-time, full-stack web apps with Node.js, FastAPI and Socket.IO." },
  { icon: "interfaces", text: "Interfaces that feel intuitive from the very first visit." },
];

// Plays its icon once when it is mostly in view, and again when the item is hovered.
const Service = ({ icon, text, delay }) => {
  const definition = SERVICE_ICONS[icon];
  const { t, play, finish } = usePlayer(definition.duration, 0);
  const itemRef = useRef(null);

  useEffect(() => {
    const el = itemRef.current;
    if (!el || !("IntersectionObserver" in window)) {
      finish();
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          play(true);
          observer.disconnect();
        }
      },
      { threshold: 0.6 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [play, finish]);

  return (
    <Reveal as="li" className="service" delay={delay} onMouseEnter={() => play()}>
      <div className="service-inner" ref={itemRef}>
        <ServiceIcon icon={definition} t={t} />
        <p>{text}</p>
      </div>
    </Reveal>
  );
};

export const Services = () => (
  <section className="services" id="services">
    <Reveal as="h2" className="section-title">What I do</Reveal>
    <ul className="services-list">
      {SERVICES.map((service, index) => (
        <Service key={service.icon} {...service} delay={index * 90} />
      ))}
    </ul>
  </section>
);
